<template>
    <div class="my-pwd-input" :class="{isError:isError,showPwdVisible:showPwdVisible,notshowPwdVisible:!showPwdVisible}">
      <el-input @input="removeSpaces" :placeholder="placeholder" ref="input" type="number"  @blur="onBlur" v-model="input1">
        <template slot="prepend">
          <div class="prepend" style=" display: flex;align-items: center;">
            <img :src="leftIcon" alt="">
            <span v-if="isLogin" style="margin-left: 5px; font-size: 13px;width: 50px;text-align: center;" >验证码</span>
            <div class="divider"></div>
          </div>
        </template>
      </el-input>
      <div class="my-pwd-input-error" v-show="isError" v-text="errorText"></div>
    </div>
  </template>
  <script>
  import $ from 'jquery';
  
  export default {
    components: {},
    model: {
      prop: 'value'
    },
    props: {
      value: {type: String, default: null},
      leftIcon: {
        type: String,
        default: require('@/assets/icons/pwd.png')
      },
      rightIcon: {
        type: String,
        default: ''
      },
      isLogin: {
        type: Boolean,
        default: false
      },
      require: {
        type: Boolean,
        default: false
      },
      errorTip: {
        type: String,
        default: '请输入'
      },
      placeholder: {
        type: String,
        default: '请输入验证码'
      },
  
    },
    computed: {},
  
    data() {
      return {input1: this.value, isError: false, errorText: this.errorTip, showPwdVisible: false};
    },
    mounted() {
      let $img = $('<img class="my-pwd-input-hideicon"/>');
      $img.attr("src", require("@/assets/icons/closeeye.png"));
      $img.click(r => {
        this.$refs.input.handlePasswordVisible()
      })
      $('.el-input__suffix-inner', this.$refs.input.$el).append($img);
      let $img2 = $('<img class="my-pwd-input-showicon"/>');
      $img2.attr("src", require("@/assets/icons/openeye.png"));
      $img2.click(r => {
        this.$refs.input.handlePasswordVisible()
      })
      $('.el-input__suffix-inner', this.$refs.input.$el).append($img2);
      this.$refs.input.$watch('passwordVisible', show => {
        this.showPwdVisible = show;
      })
    },
  
    watch: {
      input1(newval) {
        this.isError = this.isEmpty(newval)
        this.$emit('input',newval)
      },
      value(newval){
        this.input1=newval;
      }
    },
    methods: {
      onBlur() {
        if (this.require && (this.input1 == '' || this.input1 == undefined || this.input1 == null)) {
          this.isError = true;
        }
      },
      async valid(cbk) {
        await cbk(this.input1).then(j => {
          this.isError = false;
        }).catch(err => {
          this.isError = true;
          this.errorText = err||this.errorTip;
        })
        return this.isError;
      },
      removeSpaces(value){
         this.input1 = value.replace(/\s/g, '');
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  .my-pwd-input {
    width: 100%;
    height: 100%;
    border-radius: 2px;
    border: 1px solid #00000026;
    font-size: 16px;
    *{
      font-size: inherit;
    }
    &.isError {
      border: 1px solid #F53F3F;
    }
  
    position: relative;
    box-sizing: border-box;
  
    & /deep/ {
      .el-input {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        display: flex;
      }
  
      .el-input-group__prepend {
        width: auto;
        background-color: transparent;
        border: unset;
        padding: 13px 0px;
  
        img {
          margin-left: 16px;
          width:16px;
          height:16px;
        }
  
        .divider {
          display: inline-block;
          width: 1px;
          height: 12px;
          margin-left: 16px;
          background: rgba(0, 0, 0, 0.15);
        }
      }
  
      .el-input__inner {
        width: 10px;
        flex: 1;
        height: 100%;
        border: unset;
      }
  
      .my-pwd-input-error {
        position: absolute;
        left: 0;
        bottom: -17px;
        //width: 60px;
        height: 17px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #F53F3F;
        line-height: 17px;
        text-align: left;
        font-style: normal;
      }
  
  
    }
  
    &.showPwdVisible {
      & /deep/ {
        .el-input .el-input__suffix {
          display: flex;
          justify-content: center;
          align-items: center;
          .el-input__suffix-inner{
            .el-icon-view {
              display: none;
            }
            img.my-pwd-input-showicon {
              display: inline;
              width:16px;
              height:16px;
              vertical-align: middle;
              cursor: pointer;
            }
            img.my-pwd-input-hideicon {
              display: none;
              width:16px;
              height:16px;
            }
          }
  
        }
      }
    }
  
  
    &.notshowPwdVisible {
      & /deep/ {
        .el-input .el-input__suffix {
          display: flex;
          justify-content: center;
          align-items: center;
          .el-input__suffix-inner {
            .el-icon-view {
              display: none;
            }
            img.my-pwd-input-showicon {
              display: none;
            }
            img.my-pwd-input-hideicon {
              display: inline;
              vertical-align: middle;
              cursor: pointer;
              width:16px;
              height:16px;
            }
          }
        }
      }
    }
  
    /deep/ .el-input {
        input[type="number"] {
        padding-right: 0px;
        -moz-appearance: textfield;
        -webkit-appearance: textfield;
         
        line-height: 1px !important;
        }
        input[type="number"]::-webkit-inner-spin-button,
        input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
        }
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/MyCode.vue